<template>
  <div class="editable">    
    <v-textarea
      outlined
      rows="1"
    ></v-textarea>
  </div>
</template>

<script>
  export default {
    name: 'ZTypographyEditable'
  }
</script>